import { Component } from 'react';
import PropTypes from 'prop-types';
import Seeker from '@App/components/ui/Seeker';
import Waveform from '@App/components/model/Waveform';
import WaveformByUrl from '@App/components/model/WaveformByUrl';
import { formatDuration } from '@App/utils';

export default class PlayerStatus extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        audioFileUrl: PropTypes.string.isRequired,
        waveform: PropTypes.array.isRequired,
        /**
         * Sound effects carry their peaks as a URL to fetch (PSE serves them per sound), not as an
         * array bundled with the entry like music versions do. When set, the peaks are fetched and
         * normalized by WaveformByUrl, with `waveformImageUrl` as its PNG fallback.
         */
        waveformUrl: PropTypes.string,
        waveformImageUrl: PropTypes.string,
        duration: PropTypes.number.isRequired,
        time: PropTypes.number.isRequired,
        onSeek: PropTypes.func.isRequired,
        loading: PropTypes.bool.isRequired,
        highlights: PropTypes.arrayOf(PropTypes.shape({
            offset: PropTypes.number.isRequired,
            duration: PropTypes.number.isRequired,
        }))
    };

    static defaultProps = {
        waveformUrl: null,
        waveformImageUrl: null,
    };

    renderWaveform() {
        const { id, waveform, waveformUrl, waveformImageUrl, duration, time, loading, highlights, audioFileUrl } = this.props;

        if (loading) {
            return <div className="waveform loading" />;
        }

        if (waveformUrl) {
            return <WaveformByUrl
                waveformId={id}
                reference={id}
                audioFileUrl={audioFileUrl}
                waveformUrl={waveformUrl}
                waveformImageUrl={waveformImageUrl}
                duration={duration}
                progress={time / duration}
            />;
        }

        return <Waveform id={id} audioFileUrl={audioFileUrl} data={waveform} highlights={highlights} duration={duration} progress={time / duration} />;
    }

    render() {
        const { duration, time, onSeek } = this.props;

        return (
            <div className="player__waveform">
                <span>{formatDuration(Math.round(time))}</span>
                <Seeker className="seeker" onSeek={onSeek}>
                    {this.renderWaveform()}
                </Seeker>
                <span>{formatDuration(duration)}</span>
            </div>
        );
    }
}
